import React from 'react';

const YoutubeAdPreview = ({
  videoId,
  actionHeadline = 'Check out our latest offer!',
  actionButtonLabel = 'Learn More',
  finalUrls = ['https://www.example.com'],
}) => {
  const displayUrl = finalUrls && finalUrls.length > 0 ? finalUrls[0] : "brightmediasolution.com";
  let hostname = "brightmediasolution.com";
  try {
    hostname = new URL(displayUrl).hostname;
  } catch (e) {
    hostname = displayUrl || "brightmediasolution.com";
  }

  // Clean embed URL if videoId is a standard YouTube link
  let embedUrl = videoId;
  if (videoId && (videoId.includes('youtube.com') || videoId.includes('youtu.be')) && !videoId.includes('/embed/')) {
    let id = "";
    if (videoId.includes('v=')) {
      id = videoId.split('v=')[1]?.split('&')[0];
    } else {
      id = videoId.split('/').pop()?.split('?')[0];
    }
    if (id) {
      embedUrl = `https://www.youtube.com/embed/${id}`;
    }
  }

  return (
    <div style={{
      width: '100%',
      maxWidth: '440px',
      position: 'relative',
      fontFamily: '"Roboto", Arial, sans-serif',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      backgroundColor: '#000000',
      aspectRatio: '16/9'
    }}>
      {/* Video Content */}
      {embedUrl ? (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
          <iframe
            src={embedUrl}
            title="YouTube Video Ad"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0
            }}
          ></iframe>
        </div>
      ) : (
        <div style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: 'linear-gradient(to bottom, #2b2b2b, #111111)',
          color: '#fff'
        }}>
          <i className="fa fa-youtube-play" style={{ fontSize: '3rem', color: '#ff0000', marginBottom: '8px' }} />
          <span style={{ fontSize: '0.75rem', color: '#aaaaaa' }}>Select a video to preview ad</span>
        </div>
      )}

      {/* Ad Tag Top-Left */}
      <div style={{
        position: 'absolute',
        top: '12px',
        left: '12px',
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        backdropFilter: 'blur(4px)',
        color: '#ffffff',
        fontSize: '0.675rem',
        padding: '4px 8px',
        borderRadius: '4px',
        fontWeight: 'bold',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <span style={{ color: '#fbc02d' }}>Ad</span>
        <span style={{ opacity: 0.5 }}>•</span>
        <span>Sponsored</span>
      </div>

      {/* Mock "Skip Ad" Button Overlay */}
      <div style={{
        position: 'absolute',
        bottom: '48px',
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        border: '1px solid rgba(255, 255, 255, 0.25)',
        borderRight: 'none',
        color: '#ffffff',
        fontSize: '0.75rem',
        padding: '6px 12px 6px 16px',
        borderTopLeftRadius: '2px',
        borderBottomLeftRadius: '2px',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer',
      }}>
        <span>Skip Ad</span>
        <i className="fa fa-step-forward" style={{ fontSize: '0.65rem' }} />
      </div>

      {/* YouTube Dynamic Bottom CTA Overlay */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 12px',
        background: 'linear-gradient(to top, rgba(0,0,0,0.85) 40%, rgba(0,0,0,0.4) 75%, transparent)',
        color: '#ffffff',
        zIndex: 2,
        gap: '8px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, flex: 1 }}>
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <img 
              src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png" 
              alt="Channel Logo"
              style={{ width: '22px', height: '18px', objectFit: 'contain' }}
            />
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ 
              fontSize: '0.8rem', 
              fontWeight: '700',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              lineHeight: '1.2'
            }}>
              {actionHeadline}
            </div>
            <div style={{ 
              fontSize: '0.625rem', 
              color: '#cccccc',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              marginTop: '1px'
            }}>
              {hostname}
            </div>
          </div>
        </div>

        <a
          href={displayUrl.startsWith('http') ? displayUrl : `https://${displayUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: '#ff0000', // Classic YouTube red CTA button
            color: '#ffffff',
            fontSize: '0.725rem',
            padding: '6px 14px',
            borderRadius: '18px',
            textDecoration: 'none',
            fontWeight: '700',
            flexShrink: 0,
            transition: 'background-color 0.2s',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#cc0000'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ff0000'}
        >
          {actionButtonLabel}
          <i className="fa fa-external-link" style={{ fontSize: '0.6rem' }} />
        </a>
      </div>

      {/* Mock Video Control Timeline Bar (Very subtle at the very bottom edge) */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '3px',
        backgroundColor: 'rgba(255,255,255,0.2)',
        zIndex: 3
      }}>
        <div style={{
          width: '28%',
          height: '100%',
          backgroundColor: '#ff0000'
        }} />
      </div>
    </div>
  );
};

export default YoutubeAdPreview;
